export default {
  title: 'Herramientas',
  bulkRecalcTitle: 'Recalcular Model Reports en masa',
  bulkRecalcDescription: 'Vuelve a generar el Model Report de los modelos cuyo reporte se generó dentro de un rango de fechas. Úsalo para actualizar reportes anteriores a funcionalidades más nuevas.',
  afterDateLabel: 'Generado después de',
  beforeDateLabel: 'Generado antes de',
  typesLabel: 'Tipos de modelo',
  typeAdHoc: 'Ad-hoc',
  typeDiy: 'DIY',
  typeCustomEkrm: 'Custom EKRM',
  typeCustomReference: 'Custom Reference',
  batchSizeLabel: 'Modelos en paralelo',
  maxModelsLabel: 'Máx. de modelos',
  maxModelsHint: '0 = sin límite',
  previewButton: 'Previsualizar',
  matchesTitle: '{count} modelos coincidentes',
  recalculateButton: 'Recalcular {count} modelos',
  undeterminedNote: '{count} modelos tienen un reporte cuya fecha de generación no se pudo determinar y fueron excluidos.',
  headerName: 'Modelo',
  headerType: 'Tipo',
  headerDate: 'Fecha del reporte',
  headerQuality: 'Calidad',
  confirmTitle: 'Confirmar recálculo',
  confirmMessage: 'Esto iniciará el recálculo de {count} modelos. ¿Continuar?',
  cancel: 'Cancelar',
  confirm: 'Recalcular',
  progressLabel: 'Recalculando {done} de {total} modelos...',
  doneMessage: 'Recálculo finalizado para {count} modelos.',
  errorMessage: 'Algo salió mal. Por favor, inténtalo de nuevo.',
  selectAtLeastOne: 'Selecciona al menos un modelo.',
  close: 'Cerrar',
  deletedModelsTitle: 'Modelos eliminados',
  deletedModelsDescription: 'Restaura modelos eliminados en los últimos 7 días.',
  ngtorchTitle: 'Override de versión de ngtorch',
  ngtorchDescription: 'Corre ngtorch desde una rama o desde un commit específico. Mientras esté definido, cada plan, model report, EKRM y modelo DIY que dispares levanta una VM con esa versión en lugar de la que trae la imagen. Solo te afecta a ti, y solo en este entorno.',
  ngtorchBranchLabel: 'Rama',
  ngtorchCommitLabel: 'O un commit',
  ngtorchBranchHint: 'Sigue a la rama: cada ejecución levanta su último commit.',
  ngtorchCommitHint: 'Id de commit completo o corto. Fija ese commit exacto y tiene prioridad sobre la rama de arriba.',
  ngtorchRefsTruncated: 'La lista de ramas quedó truncada. Pega un id de commit si no encuentras la rama que buscas.',
  ngtorchReinstallLabel: 'Reinstalar metadatos del paquete',
  ngtorchReinstallHint: 'Más lento. Solo hace falta si la rama cambia el empaquetado, por ejemplo al agregar un módulo nuevo o un entry point.',
  ngtorchDependencyWarning: 'Una rama que agrega o actualiza una dependencia de terceros no puede correr así y sigue necesitando una imagen reconstruida.',
  ngtorchApplyButton: 'Aplicar',
  ngtorchDisableButton: 'Desactivar override',
  ngtorchActiveTitle: 'Corriendo sobre {ref}',
  ngtorchResolvedTo: 'Fijado en {sha}',
  ngtorchFollowingTitle: 'Siguiendo la rama {ref}',
  ngtorchFollowingNote: 'Cada ejecución levanta el último commit de esta rama. La última vez se resolvió a {sha}:',
  ngtorchApplied: 'Override de ngtorch fijado en {ref} ({sha}).',
  ngtorchDisabled: 'Override de ngtorch desactivado.',
  ngtorchNotFound: '"{ref}" no es una rama, tag ni commit de ngtorch.',
  ngtorchApplyError: 'No se pudo fijar el override de ngtorch. Inténtalo de nuevo.',
  ngtorchLoadRefsError: 'No se pudo cargar la lista de ramas de ngtorch.'
}
